export const emailValidator = /^[^\s@]+@[^\s@]+\.[^\s@]+$/u
